// To be set as a query param when a redirect, upon successful authentication, should include
// basic user data, such as name and email. Value should be true, otherwise, it should just be
// omitted
export const PERFORM_REDIRECT_WITH_USER_DATA = 'prwud';
